import api from './api'
import org  from './organization'

export default { api,org }
